inFunctionalCategory